package com.havn.app.core.media

import com.havn.app.core.designsystem.havnIsWebShell
import kotlin.math.absoluteValue

internal val HavnSeedWebPhotoUrls = listOf(
    "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600607687644-c7171b42498b?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600566752229-250ed79470d6?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?auto=format&fit=crop&w=1800&q=88",
    "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1800&q=88"
)

fun havnDisplayPhotoSource(
    storagePath: String?,
    thumbnailDataUrl: String?,
    thumbnailWidth: Int?
): String? {
    if (
        havnIsWebShell &&
        storagePath?.startsWith("seed/") == true &&
        (thumbnailWidth == null || thumbnailWidth <= 160)
    ) {
        return HavnSeedWebPhotoUrls[storagePath.hashCode().absoluteValue % HavnSeedWebPhotoUrls.size]
    }
    val width = thumbnailWidth?.takeIf { it > 0 } ?: 960
    val quality = if (width >= 800) 78 else 70
    return havnRenderedStorageSource(
        bucket = HavnMediaBucket.PropertyPhotos,
        source = thumbnailDataUrl,
        width = width,
        quality = quality,
        fallbackPath = storagePath
    )
}
